document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("gold-particles");

  // Number of particles on screen
  const PARTICLE_COUNT = 60;

  for (let i = 0; i < PARTICLE_COUNT; i++) {
    const particle = document.createElement("div");
    particle.classList.add("gold-particle");

    // Random size
    const size = Math.random() * 4 + 2; // 2px to 6px
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;

    // Random starting position
    particle.style.left = `${Math.random() * 100}%`;
    particle.style.top = `${Math.random() * 100}%`;

    // Random animation duration
    const duration = Math.random() * 8 + 6; // 6s to 14s
    particle.style.animationDuration = `${duration}s`;

    // Random delay
    const delay = Math.random() * 5;
    particle.style.animationDelay = `${delay}s`;

    container.appendChild(particle);
  }
});
